import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { OwnerDeleteRequestBody, OwnerDeleteResponse } from "./types";

export class OwnerDeleteAPI extends BaseAPI<
    OwnerDeleteRequestBody,
    OwnerDeleteResponse
> {
    protected route = ApiRoutes.owner.delete;
    protected method = RequestMethod.DELETE;
    protected params = ["id"]
}
